var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(-450 -627)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(450 627)",
    fill: "#3478ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reshot-icon-chat-CXDEM9ZGYL",
    d: "M77.317,47.321a.866.866,0,0,1-.6-.23l-5.156-5.183H59.387a3.167,3.167,0,0,1-3.167-3.166V28.566A3.167,3.167,0,0,1,59.387,25.4H74.949a3.167,3.167,0,0,1,3.167,3.166v4.411a.812.812,0,0,1-1.624,0V28.566a1.543,1.543,0,0,0-1.543-1.543H59.36a1.543,1.543,0,0,0-1.543,1.543V38.742a1.543,1.543,0,0,0,1.543,1.543H71.891a.812.812,0,0,1,.582.23l4.06,4.06V38.391a.812.812,0,0,1,1.624,0V46.51a.785.785,0,0,1-.5.744.568.568,0,0,1-.271.068Z",
    transform: "translate(412.768 620.586)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4f440e24a5cd098ad7c7ddef1c8d878c.svg";
export { ForwardRef as ReactComponent };